import React, { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { Input, Label } from 'reactstrap';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface Auth {
  [key: string]: any;
}

interface LanguageSelectAppsProps {
  auth: Auth;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  selectedValue: number | string;
  label?: string;
}

const LanguageSelectApps: React.FC<LanguageSelectAppsProps> = ({
  onChange,
  selectedValue,
  label
}) => (
  <div>
    <Label className="font-weight-bold">{label || getTranslationKey('selectLanguageApps')}:</Label>
    <Input type="select" value={selectedValue} onChange={onChange}>
      {Object.keys(getTranslationKey('languages') || {}).map((languageKey) => (
        <option key={languageKey} value={languageKey}>
          {getTranslationKey(`languages.${languageKey}`)}
        </option>
      ))}
    </Input>
  </div>
);

const mapStateToProps = ({ auth }: any) => ({ auth });

export default connect(mapStateToProps, actions)(LanguageSelectApps);
